<template>
    <div class="price-range-input">
        <input type="text" v-model="price">
    </div>
</template>

<script>
    export default {
        name: "PriceInput",
        props: {
            price: {
                type: [Number, String]
            }
        }
    };
</script>

<style scoped lang="scss">
    .price-range {
        &-input {
            border: 1px solid #D8DDE4;
            border-radius: 5px;
            padding: 8px 16px;
            input {
                color: #686F83;
                background: transparent;
                border: none;
                font-size: 14px;
                width: 100%;
            }

        }
    }
</style>
